export default [
    {
        path: '/login',
        name: 'login',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Logout'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/password/reset',
        name: 'forgot-password',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgottenPassword'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/password/notification',
        name: 'reset-password-notification',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPasswordNotification'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: '/password/reset/:token/:messageEmail',
        name: 'reset-password',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPassword'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        props: {
            default: true,
            topNavigation: false,
        },
    },
    {
        path: '/email/opt-out/:referralId',
        name: 'email-opt-out',
        components: {
            default: () => import(/* webpackChunkName: "auth" */ '@/views/auth/EmailOptOut'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
];
